<template>
  <v-container>
    <helmet-provider>
      <div>
        <helmet>
          <title>TextMesh Proフォント差し替えMod - 日本語化ファイル置き場 -</title>
          <meta name='description' content='主にSteamで配信されている海外ゲームの日本語化Modに関するサイトです。'>
        </helmet>
      </div>
    </helmet-provider>
    <page-title 
      title='TextMesh Proフォント差し替えMod'/>
    <page-contents 
      :contents=info />
    <page-contents 
      title="導入方法"
      :contents=guides />
    <page-contents 
      title='Mod導入前後のイメージ'
      :contents=mod />
    <game-image 
      path="Tmpfont"
      :images=images />
  </v-container>
</template>


<script>
import { HelmetProvider, Helmet } from "@jnields/vue-helmet";

import PageTitle from '@/components/PageTitle.vue'
import PageContents from '@/components/PageContents.vue'
import GameImage from '@/components/GameImage.vue'

export default {
  components: {
    PageTitle,
    PageContents,
    GameImage,
    HelmetProvider, 
    Helmet
  },
  data(){
    return{
      info: [
        '<a href="https://github.com/bbepis/XUnity.AutoTranslator" target="_blank">XUnity Auto Translator</a>は、Unity製のゲームを自動で翻訳してくれる非常に便利なModですが、ゲームがTextMesh Proを使用していた場合、Unity2018以降で作成されたゲームでしかフォントの差し替えが行えないため、古いUnityで作成されたゲームでは日本語が表示出来ないことがあります。',
        '当Modは2017以前のUnityで作成されたゲームで、TextMesh Proのフォントを日本語が表示できるものに差し替えるものです。',
      ],
      guides:[
        'フォント差し替えModはGoogleドライブに置いてあります。<a href="https://drive.google.com/drive/folders/1Ho1bw7Irs4CaVw5aXw5v0gYkdywhvJpL?usp=sharing" target="_blank">こちら</a>からダウンロードして中のreadme.txtの手順に従って導入してください。',
        '当ModはBepInEXを使用しています。BepInEx導入については、<a href="/tools/bepinex" >BepInExの導入</a>のページや他のサイトを参照してください。',
      ],
      mod: [
        '1枚目の画像は、<a href="https://store.steampowered.com/app/904380/Vambrace_Cold_Soul/" target="_blank">Vambrace: Cold Soul</a>にXUnity Auto Translatorを導入し、英語を日本語に翻訳するよう設定した状態の起動画面です。Vambrace: Cold SoulはUnity5(2017よりも前のバージョン)で作成されているため、XUnity Auto Translator側でフォントを差し替えるよう設定しても反映されません。',
        '当Modを導入することにより、2枚目のように日本語の表示が可能となります。'
      ],
      images:[
        {
          alt:'Mod導入前',
          overlay: false
        },
        {
          alt:'Mod導入後',
          overlay: false
        },
      ],
    }
  }
};
</script>
